// Copyright 2023, mochabug AB
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true,ts_nocheck=true"
// @generated from file mochabugapis/adapt/plugins/v1/file.proto (package mochabugapis.adapt.plugins.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../../buf/validate/validate_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mochabugapis/adapt/plugins/v1/file.proto.
 */
export const file_mochabugapis_adapt_plugins_v1_file: GenFile = /*@__PURE__*/
  fileDesc("Cihtb2NoYWJ1Z2FwaXMvYWRhcHQvcGx1Z2lucy92MS9maWxlLnByb3RvEh1tb2NoYWJ1Z2FwaXMuYWRhcHQucGx1Z2lucy52MSJ+CgRGaWxlEisKBG5hbWUYASABKAlCHbpIGnIYEAIYgCAyEV5bXi9dKyhcL1teL10rKSokEhgKBGRhdGEYAiABKAxCCrpIB3oFGIC0iRMSIQoJbWltZV90eXBlGAMgASgJQgm6SAZyBBABGGRIAIgBAUIMCgpfbWltZV90eXBlYgZwcm90bzM", [file_buf_validate_validate]);

/**
 * File represents a file within a plugin package.
 *
 * @generated from message mochabugapis.adapt.plugins.v1.File
 */
export type File = Message<"mochabugapis.adapt.plugins.v1.File"> & {
  /**
   * The 'name' or 'path' of the file
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 'data' contains the actual binary file data.
   *
   * @generated from field: bytes data = 2;
   */
  data: Uint8Array;

  /**
   * The mime type of the file
   *
   * @generated from field: optional string mime_type = 3;
   */
  mimeType?: string | undefined;
};

/**
 * File represents a file within a plugin package.
 *
 * @generated from message mochabugapis.adapt.plugins.v1.File
 */
export type FileJson = {
  /**
   * The 'name' or 'path' of the file
   *
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * 'data' contains the actual binary file data.
   *
   * @generated from field: bytes data = 2;
   */
  data?: string;

  /**
   * The mime type of the file
   *
   * @generated from field: optional string mime_type = 3;
   */
  mimeType?: string;
};

/**
 * Describes the message mochabugapis.adapt.plugins.v1.File.
 * Use `create(FileSchema)` to create a new message.
 */
export const FileSchema: GenMessage<File, {jsonType: FileJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_plugins_v1_file, 0);

